import useSWR from "swr"

export const useAddressSWR = (zipCode: string) => {
  const url = zipCode?.length === 7 ? "/api/get-address?zipcode=" + zipCode : null

  const { data, isValidating, error } = useSWR<{
    message: string
    results: [
      {
        address1: "東京都"
        address2: "世田谷区"
        address3: "深沢"
        kana1: "ﾄｳｷｮｳﾄ"
        kana2: "ｾﾀｶﾞﾔｸ"
        kana3: "ﾌｶｻﾜ"
        prefcode: "13"
        zipcode: "1580081"
      }
    ]
    status: 200
  }>(url, async () => {
    const res = await fetch(url)
    return await res.json()
  })

  const results = data?.results
  const hasResults = results?.length
  const couldNotFindResults = !isValidating && !results?.length

  return {
    results,
    hasResults,
    couldNotFindResults,
    isValidating,
    error,
  }
}
